<template>
  <div class="tabs-component" :class="{ fill: theme === 'fill' }">
    <div class="tabs-container" :style="{ height }">
      <div
        v-if="tab.title !== undefined"
        @click="index = tabIndex"
        v-for="(tab, tabIndex) in tabInfo"
        :class="{ active: tabIndex === index }"
        class="title"
      >
        {{ tab.title }}
      </div>
      <div
        v-if="tab.icon !== undefined"
        @click="index = tabIndex"
        v-for="(tab, tabIndex) in tabInfo"
        class="icon"
        :style="{ height }"
      >
        <div
          :style="iconStyle(tab.icon, tabIndex)"
          style="width: 20px; height: 20px; background-size: contain"
        ></div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.tabs-component {
  &.fill .tabs-container .title.active {
    background: @color-primary;
    color: white;
  }
  .tabs-container {
    display: flex;
    font-size: 13px;
    .icon {
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: solid 1px @border-color;
      text-align: center;
      cursor: pointer;
      border-right-width: 0;
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-right-width: 1px;
      }
    }
    .title {
      border: solid 1px @border-color;
      border-right-width: 0;
      flex: 1;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
      color: #000;
      &.active {
        background: white;
        color: @color-primary;
        border-color: @border-color;
        & + .title {
          border-left-color: @border-color;
        }
      }
      &:hover {
        color: @color-primary;
      }
      &:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        border-right-width: 1px;
      }
    }
  }
}
</style>

<script>
export default {
  name: "TabsComponent",
  model: {
    prop: "value",
    event: "updateValue",
  },
  props: {
    theme: {
      type: String,
      default: "border",
    },
    value: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: "36px",
    },
  },
  data() {
    return {
      tabInfo: [],
      index: this.value,
    };
  },
  mounted() {
    this.tabInfo = this.$children.map((p) => {
      return {
        title: p.title,
        icon: p.icon,
      };
    });
  },
  watch: {
    index(val) {
      this.$children.forEach((panel, index) => {
        panel.show = index === val;
      });
      this.$emit("updateValue", val);
    },
    value(val) {
      this.index = val;
    },
  },
  methods: {
    iconStyle(icon, index) {
      if (index === this.index) {
        return {
          "background-image": `url(${icon.active})`,
        };
      } else {
        return {
          "background-image": `url(${icon.void})`,
        };
      }
    },
  },
};
</script>
